import { useQuery } from '@tanstack/react-query';

import axiosClient from '@/shared/lib/axios';
import { IGeneral } from '@/shared/types';

//***************** Crops *****************//

//  get all crops
const getAllCrops = async (
  entityId: number | undefined
): Promise<{ list: IGeneral.ICropSchema[] }> => {
  const { data } = await axiosClient.get('/company/portalInsights/crops', {
    params: { entityId },
  });
  return data;
};
export const useGetAllCrops = (entityId: number | undefined) => {
  return useQuery({
    queryKey: ['getAllCrops'],
    queryFn: () => getAllCrops(entityId),
    enabled: !!entityId,
  });
};

//  Get crop variety
const getCropVarieties = async (
  cropId?: number
): Promise<IGeneral.ICropSchema[]> => {
  const { data } = await axiosClient.get(
    `/company/portalInsights/crop/varieties/${cropId}`
  );
  return data;
};
export const useGetCropVarieties = (cropId?: number) => {
  return useQuery({
    queryKey: ['getCropVarieties', cropId],
    queryFn: () => getCropVarieties(cropId),
    enabled: !!cropId,
  });
};
